import "./BillingStatus.scss"
import React from "react"
import moment from "moment"
import { Banner } from "../../lib"
import { observer } from "mobx-react"
import { billingStore } from "../../app/stores"

const BillingStatus = () => {
  const {
    subscriptionData,
    payment,
    subscription,
    subscribed,
    cancelled,
    activePlan,
  } = billingStore
  if (subscribed) {
    if (subscriptionData && payment) {
      return (
        <Banner title={`You're on Smallchat ${activePlan.name}`}>
          Your {payment.brand} card ending in {payment.last4} will be
          automatically charged on{" "}
          {moment(subscriptionData.current_period_end * 1000).format(
            "MMM Do, YYYY"
          )}.
        </Banner>
      )
    } else {
      return (
        <Banner title="You’re on our Pro tier">
          We're not charging you anything on this account.
        </Banner>
      )
    }
  } else {
    if (cancelled) {
      return (
        <Banner title={`You're on Smallchat ${activePlan.name}`}>
          Your subscription expires on{" "}
          {moment(subscription.planEnds * 1000).format("MMM Do, YYYY")}.
        </Banner>
      )
    } else {
      return (
        <Banner title={`You’re on Smallchat ${activePlan.name}`}>
          You can upgrade any time
        </Banner>
      )
    }
  }
}

BillingStatus.displayName = "BillingStatus"

export default observer(BillingStatus)



// WEBPACK FOOTER //
// ./src/account/billing/BillingStatus.js